
// BLE Service and configuration UUID-s
export const FIREPLACE_SERVICE_UUID = 0x8AE1;

export const FILE_WRITER_CHAR_UUID = 0x8B01;
export const FILE_READER_CHAR_UUID = 0x8B02;
export const REBOOT_DEVICE_CHAR_UUID = 0x8B10;
export const VERSION_DEVICE_CHAR_UUID = 0x8B11;
